import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login.service';
import { Router } from '@angular/router';
import { PerfilService } from 'src/app/service/perfil.service';
import { TarjetasService } from 'src/app/service/tarjetas.service';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  session: any;
  nombre: string;
  suscription: any
  user: any;
  isActive: boolean = false;

  constructor(private login: LoginService, private route: Router, private perfil: PerfilService, private tarjetas: TarjetasService, private auth: AuthService) {
    this.login.currentSession.subscribe(login => {
      this.session = login
    });
    this.perfil.currentUser.subscribe(user => this.user = user)
  }


  ngOnInit() {

    this.verificar();
    this.nombre = this.session.nombre

  }
  ngAfterViewInit() {
    this.nombre = this.user.nombre + " " + this.user.apePaterno;
  }

  ngOnchange() {

  }


  setMenu() {
    if (this.isActive) {
      this.isActive = false;
    } else {
      this.isActive = true;
    }
  }

  verificar() {

    if (!localStorage.hasOwnProperty('sesionPocae')) {
      // localStorage.clear()
      this.auth.logout(true)
      this.route.navigate(['/'])
    }
  }

  closeSession() {
    try {
    // 1) marca logout para interceptores / otras pestañas
    localStorage.setItem('loggingOut', '1');

    // 2) cancelar peticiones
    this.auth.cancelPendingRequests$.next();

    // 3) limpiar UI local (tarjetas)
    this.tarjetas.addCards([]);
    if ((this.tarjetas as any).cancelRequests) (this.tarjetas as any).cancelRequests();

    // 4) delegar limpieza final en AuthService (que hará removeItem de keys)
    setTimeout(() => {
      this.auth.logout(true);
    }, 80);
  } catch (err) {
    console.error('Error en closeSession:', err);
    this.auth.logout(true)
    this.route.navigate(['/']);
  }
  }

}
